import Console from 'utility/Debug/Console';

import {
    EventConfig,
    EventConfigDefinition,
    PENDING_STATES,
    PollEventData,
    PollingEventType,
    PollingStatus,
    PreviousEventDataMap,
} from '../types';

/**
 * calls the callback with the given arguments, wrapped within try-catch block to ensure internal failsafe
 */
export function callSafe<Arguments extends unknown[]>(
    callback?: (...args: Arguments) => void,
    ...args: Arguments
) {
    try {
        callback?.(...args);
    } catch (e) {
        Console.error(e);
    }
}

/**
 * calls the given callback for all events considered pending
 */
export function forEachPendingEvent(
    events: EventConfig,
    previousEventData: PreviousEventDataMap,
    callback: (
        event: EventConfigDefinition,
        previousData: PollEventData | undefined
    ) => void
) {
    Object.entries(events).forEach(([type, event]) => {
        const previousData = previousEventData.get(type as PollingEventType);
        if (
            PENDING_STATES.has(
                previousData?.event.status ?? PollingStatus.Running
            )
        ) {
            callSafe(callback, event, previousData);
        }
    });
}
